import Notiflix from 'notiflix';

/**
 * This function is used to format the data before outputting it on the screen
 * @param data The data to output on the screen
 * @returns The formated object of the data
 */
export const outputData = (data: object): object => {
  return {
    ...data,
  };
};

/**
 * This function either creates a new history in the localstorage if there is none or
 * retrieves the history of the localstorage and adds the current session as new item.
 * @param data The data to store
 */
export const saveData = (data: object): void => {
  const timestamp: number = Date.now();
  const historyOldString: any = localStorage.getItem('dataskopHistory');

  if (historyOldString) {
    try {
      const historyOldObj: any = JSON.parse(historyOldString);
      const currentSession = {
        timestamp,
        data,
      };

      historyOldObj.push(currentSession);
      const historyNewString = JSON.stringify(historyOldObj);
      localStorage.setItem('dataskopHistory', historyNewString);
    } catch (error) {
      console.error(error);
    }
  } else {
    const history = [
      {
        timestamp,
        data,
      },
    ];

    localStorage.setItem('dataskopHistory', JSON.stringify(history));
  }
  Notiflix.Notify.success('Current Session saved!', { fontSize: '14px' });
};

/**
 * Simple utititly function that adds a zero infront of the passed number if it rerquires one.
 * @param n The number to add a zero to
 * @returns The number with a zero if it hadn't already one
 */
const addZeroBefore = (n: number): string => {
  return (n < 10 ? '0' : '') + n;
};

/**
 * The function creates a formated time stamp based on the passed milliseconds.
 * @param timestamp The timestamp in milliseconds
 * @returns The formated time string
 */
export const formatTimeStamp = (timestamp: number): string => {
  const a = new Date(timestamp);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const year = a.getFullYear();
  const month = months[a.getMonth()];
  const day = addZeroBefore(a.getDate());
  const hour = addZeroBefore(a.getHours());
  const min = addZeroBefore(a.getMinutes());
  const sec = addZeroBefore(a.getSeconds());

  return `Time ⏰: ${hour}:${min}:${sec} ⚊ Day 📅: ${day}. ${month}. ${year}`;
};

/**
 * The function returns the ids from the constructed dataskop configuration JSON.
 * @param obj The object to extract the ids from
 * @returns An array of ids as string
 */
export const grabIdsFromData = (obj: {
  attributes?: { id?: string }[];
}): string[] => {
  if (!obj?.attributes?.length) {
    return [''];
  } else {
    const ids = obj.attributes
      .filter((attr) => attr.id !== undefined)
      .map(({ id }) => id!);
    return ids.length ? ids : [''];
  }
};

/**
 * This function formats a given date string to a specific format.
 * @param dateString Date string to be formatted in format: 'dd.mm.yyyy, HH:MM:SS'
 * @returns Date string formatted in format: '📅 dd.mm.yyyy - 🕐HH:MM:SS'
 */
export const formatDateString = (dateString: string): string => {
  const [date, time] = dateString.split(", ");
  const [day, month, year] = date.split(".");
  const formattedDate = `📅 ${day}.${month}.${year}`;
  const formattedTime = `🕐 ${time}`;
  return `${formattedDate} - ${formattedTime}`;
}

/**
 * Utility function to wrap JSON data in an additionalProperties object,
 * stringify it, and escape all quotes except the first and last ones.
 * @param data - The JSON data to be processed.
 * @returns A stringified and escaped JSON object.
 */
 export const formatJsonForBackend = (data: any): string => {
  const jsonString = JSON.stringify(data);
  const escapedJsonString = jsonString.replace(/"/g, '\"');
  const requestBody = {
    additionalProperties: escapedJsonString,
  };
  return JSON.stringify(requestBody);
}